import React from 'react'
import { localized } from '@/decorators/localized'
import { FileAttachments } from '@/components/fileAttachments'
import LoadingIndicator from '@/components/LoadingIndicator'
import { DataLoader } from '@/components/dataLoader'
import { Label } from 'reactstrap'
import Resx from '@/components/Resx'

@localized()
class SubmittedXmls extends React.Component {
  render () {
    return (
      <div className='mt-2'>
        <div><Label><Resx name='Reporting.SubmittedXmls' /></Label></div>
        <div>
          <DataLoader
            dataSource={this.props.dataSource}
            render={({ data, loading }) => {
              if (loading) return (<LoadingIndicator />)
              return (
                <FileAttachments
                  readonly
                  attachments={data}
                  downloadAction={this.props.downloadAction} />
              )
            }} />
        </div>
      </div>
    )
  }
}

export default SubmittedXmls



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/xmlSigning/submittedXmls.js